import React from "react";
import BackBtn from "../components/BackBtn";
import SaveBadge from "../components/SaveBadge";
import ActionMenu from "../components/ActionMenu";
import { Chip, LibIcon, Tag, StarBtn } from "../components/ui";
import { FF, T } from "../lib/constants";

// Oefeningen-sectie (Training Deck of de oude lijst extra oefeningen), in de stijl van
// build 2.5: kaarten met rand, mappen met een icoon, acties achter het ⋯-menu.
export default function Drills({
  mob, pd, lv, sel, drills, sav,
  curFolder, setCurFolder, drillFilter, setDrillFilter,
  canEdit, setSelDi, setScr, setMoveItem, setMdl, confirmDel,
  addDrillItem, addFolder, renameFolder,
  renderModal, onBack, backLabel, embedded, isFav, toggleFav,
}) {
  var allItems = drills[sel] || [];
  var curItems = allItems.filter(function (x) { return (x.folderId || null) === curFolder; });
  var ink = lv.ink || lv.color;

  function getDescendantFolderIds(folderId) {
    var result = [folderId];
    var children = allItems.filter(function (x) { return x.type === "folder" && x.parentId === folderId; });
    children.forEach(function (c) { result = result.concat(getDescendantFolderIds(c.id)); });
    return result;
  }
  // Filter op tags: binnen de huidige map en alle submappen (in de hoofdmap: alles).
  var folderScope = curFolder ? getDescendantFolderIds(curFolder) : null;
  function inScope(x) { return !folderScope || folderScope.indexOf(x.folderId) >= 0 || (curFolder === null); }

  var scopedTags = [];
  allItems.forEach(function (d3) {
    if (d3.type !== "drill" || !inScope(d3)) return;
    (d3.tags || []).forEach(function (t) { if (scopedTags.indexOf(t) < 0) scopedTags.push(t); });
  });
  scopedTags.sort(function (a, b) { return a.localeCompare(b, "nl"); });

  var filtering = drillFilter.length > 0;
  var filteredItems = curItems;
  if (filtering) {
    filteredItems = allItems.filter(function (x) {
      if (x.type !== "drill" || !inScope(x)) return false;
      if (!x.tags || x.tags.length === 0) return false;
      return drillFilter.every(function (ft) { return x.tags.indexOf(ft) >= 0; });
    });
  }
  var folders = filtering ? [] : filteredItems.filter(function (x) { return x.type === "folder"; });
  var drillItems = filteredItems.filter(function (x) { return x.type === "drill"; });

  var breadcrumb = [];
  if (curFolder) {
    var cur = allItems.find(function (x) { return x.id === curFolder; });
    while (cur) {
      breadcrumb.unshift(cur);
      cur = cur.parentId ? allItems.find(function (x) { return x.id === cur.parentId; }) : null;
    }
  }
  function toggleTag(t) {
    if (drillFilter.indexOf(t) >= 0) setDrillFilter(drillFilter.filter(function (x) { return x !== t; }));
    else setDrillFilter(drillFilter.concat([t]));
  }
  function itemMenu(it) {
    if (!canEdit) return null;
    return <ActionMenu center items={[
      { icon: "↗", label: "Verplaatsen naar map…", onClick: function () { setMoveItem(it.id); setMdl("moveTo"); } },
      { icon: "×", label: it.type === "folder" ? "Map verwijderen" : "Oefening verwijderen", danger: true, onClick: function () { confirmDel("drill", it.id); } },
    ]} />;
  }
  var card = { background: T.card, border: "1px solid " + T.line2, borderRadius: 14, boxSizing: "border-box" };

  return (
    <div style={embedded ? { fontFamily: FF } : { minHeight: "100vh", padding: "16px " + pd + "px 40px", fontFamily: FF, maxWidth: 1100, margin: "0 auto", boxSizing: "border-box" }}>
      {!embedded && <SaveBadge show={sav} />}
      {!embedded && <BackBtn label={backLabel || "Bibliotheek"} onClick={onBack || function () { setScr("home"); }} />}
      {!embedded && <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
        <span aria-hidden="true" style={{ width: 14, height: 14, borderRadius: 4, background: lv.color }} />
        <h1 style={{ fontSize: mob ? 24 : 30, color: T.ink, fontWeight: 800, margin: 0 }}>{lv.label}</h1>
      </div>}

      {(!embedded || breadcrumb.length > 0) && <nav aria-label="Mappen" style={{ display: "flex", alignItems: "center", gap: 4, margin: embedded ? "0 0 10px" : "6px 0 14px", flexWrap: "wrap", fontSize: 14 }}>
        <button type="button" onClick={function () { setCurFolder(null); setDrillFilter([]); }}
          style={{ background: "none", border: "none", cursor: curFolder ? "pointer" : "default", color: curFolder ? T.primary : T.ink, fontWeight: 700, fontFamily: FF, padding: "6px 2px", minHeight: 32 }}>Alle mappen</button>
        {breadcrumb.map(function (f, i) {
          var last = i === breadcrumb.length - 1;
          return (
            <React.Fragment key={f.id}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8A857B" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><path d="M9 18l6-6-6-6" /></svg>
              <button type="button" onClick={function () { setCurFolder(f.id); setDrillFilter([]); }}
                style={{ background: "none", border: "none", cursor: last ? "default" : "pointer", color: last ? T.ink : T.primary, fontWeight: 700, fontFamily: FF, padding: "6px 2px", minHeight: 32 }}>{f.name || "Naamloze map"}</button>
            </React.Fragment>
          );
        })}
      </nav>}

      {scopedTags.length > 0 && (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginBottom: 16 }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", color: T.muted, marginRight: 4 }}>Tags</span>
          {scopedTags.map(function (t) {
            return <Chip key={t} active={drillFilter.indexOf(t) >= 0} color={ink} bg={lv.bg} onClick={function () { toggleTag(t); }}>{t}</Chip>;
          })}
          {filtering && <button type="button" onClick={function () { setDrillFilter([]); }} style={{ background: "none", border: 0, color: T.primary, fontWeight: 700, fontSize: 13, cursor: "pointer", minHeight: 34, fontFamily: FF }}>Wissen</button>}
        </div>
      )}
      {filtering && <p style={{ fontSize: 12, color: T.muted, margin: "-6px 0 12px" }}>{curFolder ? "Filter toont oefeningen uit deze map en submappen." : "Filter toont oefeningen uit alle mappen."}</p>}

      <div style={{ display: "grid", gridTemplateColumns: mob ? "minmax(0, 1fr)" : "repeat(auto-fill, minmax(260px, 1fr))", gap: 12 }}>
        {folders.map(function (f) {
          var count = allItems.filter(function (x) { return x.folderId === f.id; }).length;
          return (
            <div key={f.id} style={{ position: "relative", display: "flex" }}>
              <div role="button" tabIndex={0} onClick={function () { setCurFolder(f.id); setDrillFilter([]); }}
                onKeyDown={function (e) { if (e.key === "Enter") { setCurFolder(f.id); setDrillFilter([]); } }}
                style={Object.assign({}, card, { flex: 1, display: "flex", alignItems: "center", gap: 12, padding: canEdit ? "12px 52px 12px 14px" : "12px 14px", cursor: "pointer", minHeight: 64 })}>
                <span style={{ width: 40, height: 40, borderRadius: 10, background: lv.bg, color: ink, display: "flex", alignItems: "center", justifyContent: "center", flex: "none" }}><LibIcon name="folder" size={20} /></span>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {canEdit
                    ? <input value={f.name} aria-label="Naam van de map" onClick={function (e) { e.stopPropagation(); }} onKeyDown={function (e) { e.stopPropagation(); }} onChange={function (e) { renameFolder(f.id, e.target.value); }}
                        style={{ width: "100%", border: "none", borderBottom: "1px dashed " + T.line, background: "transparent", fontFamily: FF, fontSize: 15, color: T.ink, outline: "none", padding: "2px 0", fontWeight: 800 }} />
                    : <div style={{ fontSize: 15, color: T.ink, fontWeight: 800 }}>{f.name || "Naamloze map"}</div>}
                  <div style={{ fontSize: 12, color: T.muted }}>{count} {count === 1 ? "item" : "items"}</div>
                </div>
              </div>
              {itemMenu(f)}
            </div>
          );
        })}
        {drillItems.map(function (d) {
          return (
            <div key={d.id} style={{ position: "relative", display: "flex" }}>
              <button type="button" onClick={function () { setSelDi(d.id); setScr("drillD"); }}
                style={Object.assign({}, card, { flex: 1, padding: 0, cursor: "pointer", textAlign: "left", overflow: "hidden", display: "flex", flexDirection: "column", fontFamily: FF })}>
                <span style={{ height: mob ? 0 : 96, display: mob ? "none" : "flex", width: "100%", background: T.soft, borderBottom: "1px solid " + T.line, alignItems: "center", justifyContent: "center", color: "#8A857B", overflow: "hidden" }}>
                  {d.photo
                    ? <img src={d.photo} alt="" loading="lazy" decoding="async" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                    : <LibIcon name={d.diagram ? "court" : "image"} size={22} />}
                </span>
                <span style={{ padding: "12px " + ((canEdit ? 52 : 14) + (toggleFav && mob ? 40 : 0)) + "px 12px 14px", display: "flex", flexDirection: "column", gap: 6, width: "100%", boxSizing: "border-box" }}>
                  <span style={{ fontSize: 15, fontWeight: 800, color: d.name ? T.ink : "#B5B0A6", lineHeight: 1.25 }}>{d.name || "Naamloze oefening"}</span>
                  {d.tags && d.tags.length > 0 && <span style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{d.tags.map(function (t, j) { return <Tag key={j} text={t} lv={lv} />; })}</span>}
                </span>
              </button>
              {toggleFav && <StarBtn on={isFav(d.id)} label={d.name || ""} onClick={function () { toggleFav(d.id); }} style={mob ? { position: "absolute", right: canEdit ? 50 : 4, top: "50%", marginTop: -22 } : { position: "absolute", right: 6, top: 6, width: 40, height: 40, borderRadius: 20, background: "rgba(255,255,255,.92)" }} />}
              {itemMenu(d)}
            </div>
          );
        })}
        {canEdit && !filtering && (
          <button type="button" onClick={addDrillItem} style={{ minHeight: 64, border: "2px dashed #CFC9BD", borderRadius: 14, background: "transparent", color: T.muted, fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer", fontFamily: FF }}>
            <LibIcon name="plus" />Nieuwe oefening
          </button>
        )}
        {canEdit && !filtering && (
          <button type="button" onClick={addFolder} style={{ minHeight: 64, border: "2px dashed #CFC9BD", borderRadius: 14, background: "transparent", color: T.muted, fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer", fontFamily: FF }}>
            <LibIcon name="folder" />Nieuwe map
          </button>
        )}
      </div>
      {filteredItems.length === 0 && filtering && <p style={{ textAlign: "center", color: T.muted, marginTop: 40, fontSize: 14 }}>Geen oefeningen gevonden met deze tags.</p>}
      {filteredItems.length === 0 && !filtering && !canEdit && <p style={{ textAlign: "center", color: T.muted, marginTop: 40, fontSize: 14 }}>Geen oefeningen in deze map.</p>}
      {!embedded && renderModal()}
    </div>
  );
}
